export default "__VITE_ASSET__BHIfJ3iq__"